var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:['label', _vm.classname]},[_vm._v("\n  "+_vm._s(_vm.field.label.text)+"\n  "),(_vm.field.mandatory)?_c('strong',{staticClass:"field--required"},[_vm._v("*")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }